import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import Weekday from './Weekday'
import css from './week.css'

const calculateDate = (date, offset) => date.clone().add(offset, 'days').format('DD')
const DAY_NAMES = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

const BigWeek = (props) => {
  const { date } = props
  const wkdayIndToday = parseInt(date.format('e')) // Sun-Sat as 0-6

  return (
    <div className={css.wrapper}>
      {DAY_NAMES.map((dayName, dayInd) => (
        <Weekday
          key={dayName}
          active={wkdayIndToday === dayInd}
          dayName={dayName}
          dayOfMonth={calculateDate(date, dayInd - wkdayIndToday)}
        />
      ))
      }
      <div className={css.datePicker}>
        {props.children}
      </div>
    </div>
  )
}

BigWeek.propTypes = {
  date: PropTypes.instanceOf(moment),
}

export default BigWeek



// WEBPACK FOOTER //
// ./src/components/Schedule/Header/Week.js